import { useState } from "react";
import ApiClient from "../../../../methods/api/apiClient";
import loader from "../../../../methods/loader";
import "./style.scss";
import Html from "./Html";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login_success } from "../../../../redux/actions/user";
import { toast } from "react-toastify";

const EditProfile = () => {
  const history = useNavigate()
  const dispatch = useDispatch()
  const user = useSelector((state: any) => state.user)
  const [submitted, setSubmitted] = useState(false)
  const [form, setForm]: any = useState({
    id: user?.id || user?._id,
    email: user?.email,
    firstName: user?.firstName,
    lastName: user?.lastName,
    dialCode: user?.dialCode,
    mobileNo: user?.mobileNo,
    image: user?.image,
    isTwillio: user?.isTwillio || false,
  })

  const goBack = () => {
    history("/profile")
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    setSubmitted(true)
    if(!form?.mobileNo) return
    let value = {
      ...form,
      isTwillio: form?.isTwillio == true ? true : false
    }
    loader(true)
    ApiClient.put("user/profile", value).then((res) => {
      if (res.success) {
        let data = { ...user, ...value }
        dispatch(login_success(data))
        history("/profile")
        loader(false)
      } else {
        toast?.error(res?.message)
        loader(false)
      }
    })
  }

  const ImageUpload = (e: any) => {
    let files = e.target.files
    let file = files.item(0)
    loader(true)
    ApiClient.postFormData('upload/image', { file: file, modelName: '' }).then(res => {
      if (res.success) {
        setForm({ ...form, image: res?.fileName })
      }
      loader(false)
    })
  }

  const handleChangePhone = (phone: any, country: any) => {
    const dialCode = country?.dialCode
    setForm((prev: any) => ({ ...prev, dialCode: dialCode, mobileNo: phone?.replace(dialCode, "") }))
  }

  return (
    <>
      <Html
        handleSubmit={handleSubmit}
        setForm={setForm}
        form={form}
        submitted={submitted}
        handleChangePhone={handleChangePhone}
        goBack={goBack}
        ImageUpload={ImageUpload}
      />
    </>
  );
};

export default EditProfile;
